import { motion } from "framer-motion";
import { Reveal, Eyebrow } from "./Reveal";
import { AREAS } from "./content";

const TONES = { rose: "bg-blush", yellow: "bg-butter", mint: "bg-mint" };

const Card = ({ a, i }) => (
  <motion.article data-testid={`area-card-${a.key}`}
    initial={{ opacity: 0.001, y: 40 }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ y: -6 }}
    className={`${a.span} ${TONES[a.tone]} rounded-[2rem] p-8 sm:p-10 flex flex-col justify-between min-h-[320px]`}>
    <span className="self-start rounded-full bg-cream/70 px-4 py-1.5 text-xs uppercase tracking-[0.2em] font-semibold text-sage">{a.tag}</span>
    <div className="mt-16">
      <h3 className="font-display text-3xl sm:text-4xl text-ink leading-[1.1] max-w-md">{a.title}</h3>
      <p className="mt-4 text-ink/75 leading-relaxed max-w-md">{a.text}</p>
    </div>
  </motion.article>
);

export const Areas = () => (
  <section id="areas" data-testid="areas-section" className="py-24 md:py-36">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
        <div>
          <Reveal><Eyebrow>Áreas de atendimento</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl text-ink leading-[1.05] tracking-tight max-w-2xl">
              Para quem é <span className="italic text-sage">esse espaço</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2}><p className="text-ink/70 max-w-sm">Adolescentes, adultos e famílias que desejam se escutar melhor.</p></Reveal>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-5 lg:gap-6">
        <Card a={AREAS[0]} i={0} />
        <Card a={AREAS[1]} i={1} />
        <Card a={AREAS[2]} i={2} />
        <Reveal className="md:col-span-7 min-h-[320px] rounded-[2rem] overflow-hidden relative">
          <img src="/img/teens.jpg" alt="Grupo de adolescentes rindo juntos" className="absolute inset-0 w-full h-full object-cover object-[50%_35%] transition-transform duration-[1.6s] hover:scale-105" />
          <p className="absolute left-6 bottom-6 right-6 font-display italic text-2xl sm:text-3xl text-cream drop-shadow-[0_2px_12px_rgba(0,0,0,0.45)]">
            “A adolescência é o presente em transformação.”
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
